'use strict';

angular.module('shiftTraderApp')
    .directive('saModifyColor', function ($timeout) {
      return {
        restrict: 'A',
        link: function(scope, elem, attrs) {
          var selectionNode = $(elem).find(attrs.saModifyColor);
          var properties = _.map(attrs.property.split(','), String.trim);

          $timeout(function() {
            var nodesWithProperties = selectionNode.find('div').filter(function(i, e) {
              var el = $(e);
              return _.any(properties, function(prop) {
                return el.css(prop) !== 'rgba(0, 0, 0, 0)';
              });
            });

            if (nodesWithProperties.length > 0) {
              var data = {};
              var theColor;
              nodesWithProperties.each(function(i, e) {
                var el = $(e);
                data = {};

                _.each(properties, function(prop) {
                  if (el.hasClass('block_recolor_' + prop)) {
                    console.log('skipping ' + prop);
                  } else {
                    if (el.css(prop) !== 'rgba(0, 0, 0, 0)') {
                      theColor = tinycolor(el.css(prop));
                      var theValue = parseInt(attrs.val);
                      if (theValue > 100) {
                        theValue = 100;
                      } else if (theValue < 0) {
                        theValue = 0;
                      }
                      data[prop] = '#' + theColor[attrs.method](theValue).toHex();
                    }
                  }
                });
                el.css(data);
              });
            }
          }, 100);
        }
      };
    });
